import { useApplicationDispatch, useApplicationSelector } from '../../../../../Redux/ReduxStore';
import { selectValueMatrixTableInputsRequest, setValueMatrixTableInputsRequest } from '../../../../../Redux/Slices/ValueMatrixCalculatorSlice';
import Dropdown from '../../../../Components/Form/Inputs/Dropdown';
import useLanguage from '../../../../Services/Language/useLanguageHook';
import styles from '../ValueMatrixCalculator.module.scss';
import { timeSpanOptions } from '../ValueMatrixDefinitions';

const ValueMatrixYearsToLookBackDropdown: React.FC = () => {
    const [translations] = useLanguage();
    const dispatch = useApplicationDispatch();
    const valueMatrixTableInputs = useApplicationSelector(selectValueMatrixTableInputsRequest);

    return (
        <div className={styles.value_matrix_dropdown}>
            <Dropdown
                testId="ValueMatrixYearsToLookBackDropdown"
                value={valueMatrixTableInputs.timeSpan as number}
                options={timeSpanOptions}
                handleOptionChange={(value: number) => {
                    dispatch(
                        setValueMatrixTableInputsRequest({
                            ...valueMatrixTableInputs,
                            timeSpan: +value,
                            updateTriggeredBy: 'generalFieldSelectionOrUpdate',
                        }),
                    );
                }}
                label={translations.calculators.valueMatrix.fields.yearsToLookBack}
                track={{ eventCategory: 'ValueMatrixCalculator', eventAction: 'YearsToLookBackChanged' }}
            />
        </div>
    );
};

export default ValueMatrixYearsToLookBackDropdown;
